$(document).ready(function(){  
  $(".return-btn button").on('click', function() {

      	if(history.length > 1 && document.referrer != ""){
			window.history.back();
        } else {
         	location.href = "https://www.stonecandles.com/pages/collection"; 
        }

  });
});


$('a.build-your-own-brand').click(function(e) {
  if (this.hostname && this.hostname == 'light4lifecause.com') {
    if (!confirm("You are leaving our site. Do you want to proceed?")) {
      e.preventDefault(); // Stops navigation
    }
  }
});